import { useRef, useState, useEffect, useContext } from "react";
import { PropertiesCountCard } from "../../../../shadcn/components/custom/PropertiesCountCard";
import { Context, getSearchResults, getWatermarkedImgixUrl } from "services";

interface PropertiesData {
  propertyCount?: string;
  subAssetType?: string;
  locality?: string;
  imageLink?: string;
  propertyLink?: string;
}

export default function FlatsResidence() {
  const { searchForm }: any = useContext(Context);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [propertiesData, setPropertiesData] = useState<PropertiesData[]>([]);

  const init = async () => {
    const FlatsResidenceImageLinks = [
      getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/c4a91852-373b-4fd6-a618-88b8bf3282ee`,
      ),
      getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5191100a-3811-495b-a8ca-67e07194d892`,
      ),
      getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/6bb0de4c-e3b5-4efd-87e0-a411f7c3c835`,
      ),
    ];
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          query_by: "",
          facet_by: "dump.asset.sub_asset_type_slug",
          facet_return_parent: "dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: `status:active &&dump.asset.asset_type_slug:${
            searchForm?.value?.asset_type?.value
          }  ${
            searchForm?.value?.city?.label !== "All Cities"
              ? `&& dump.location.city_name:${searchForm?.value?.city?.label}`
              : ""
          }`,
          max_facet_values: "500",
          per_page: 0,
        },
        {
          collection: "properties",
          q: "*",
          query_by: "",
          facet_by: "dump.asset.sub_asset_type_slug",
          facet_return_parent: "dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: `status:active && dump.asset.asset_type_slug:!=${
            searchForm.value.asset_type.value
          } ${
            searchForm?.value?.city?.label !== "All Cities"
              ? `&& dump.location.city_name:${searchForm?.value?.city?.label}`
              : ""
          }`,
          max_facet_values: "500",
          per_page: 0,
        },
      ],
    });

    const filteredPropertiesData =
      [
        ...(data.results[0]?.facet_counts?.[0]?.counts || []),
        ...(data.results[1]?.facet_counts?.[0]?.counts || []),
      ].map((facet: any, index: number) => ({
        propertyCount: facet.count,
        subAssetType: facet.parent.sub_asset_type_name,
        locality: searchForm.value.city.label,
        imageLink:
          FlatsResidenceImageLinks[index % FlatsResidenceImageLinks.length],
        propertyLink:
          searchForm?.value?.city?.label !== "All Cities"
            ? `/${facet.parent.asset_type_slug}-${facet.parent.sub_asset_type_slug}-auction-properties-in-${searchForm?.value?.city?.value}`
            : `/${facet.parent.asset_type_slug}-${facet.parent.sub_asset_type_slug}-auction-properties`,
      })) || [];

    setPropertiesData(filteredPropertiesData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, [searchForm.value.city]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        2.3 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${scrollPercentage}%`,
      );
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);

  return (
    <>
      <div className="w-full pl-4 lg:px-customPadding mt-4 pt-[42px] py-[62px] lg:mt-20 lg:py-[50px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 ">
        {/* Heading */}
        <div className="flex items-center pr-[60px] lg:pr-0">
          <p className="font-spaceGrotesk font-normal text-mobile-h2 leading-[35px] lg:text-web-h2 lg:leading-[57px] text-brand-textBlack">
            FLATS , RESIDENCE & MORE
          </p>
        </div>
        {/* Cards */}
        <div className="relative">
          <div
            ref={scrollContainerRef}
            className="overflow-auto w-full flex lg:grid lg:grid-cols-3 lg:gap-4 mt-8 lg:mt-[70px] custom-scrollbar"
          >
            {" "}
            {propertiesData.splice(0, 3).map((item, index) => (
              <div key={`upcoming_${index}`}>
                <PropertiesCountCard
                  propertyCount={item?.propertyCount}
                  locality={item.locality}
                  imageLink={item.imageLink}
                  propertyLink={item.propertyLink}
                  subAssetType={item.subAssetType}
                  className="mr-6 min-w-[320px] lg:min-w-0"
                />
              </div>
            ))}
            <div
              className="lg:hidden absolute 
               custom-scrollbar-track translate-y-4"
            />
          </div>
        </div>
      </div>
    </>
  );
}
